/**
 * The app is served under a base path (e.g. /murdoku/) behind a shared proxy, and in production it
 * may sit at the root instead. Next's <Link> prefixes automatically; anything we hand to the
 * browser ourselves — redirect targets, OAuth callbacks — has to be prefixed here.
 */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export const withBasePath = (path: string): string =>
  `${BASE_PATH}${path.startsWith("/") ? path : `/${path}`}`;
